/*
Site Modal
*/

class SiteModal extends HTMLElement {
  connectedCallback() {
    this.registerEvents();
    this.modal = this.querySelector(".modal");
  }

  openModal() {
    if (this.modal) {
      this.modal.classList.add("active");
      const video = this.modal.querySelector("video");
      if (video) {
        // A poster attribute downloads at page load even inside a closed
        // modal, so it ships as data-poster and is only applied on open.
        if (video.dataset.poster && !video.hasAttribute("poster")) {
          video.setAttribute("poster", video.dataset.poster);
        }
        video.play().catch(() => {});
      }
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.classList.remove("active");
      const video = this.modal.querySelector("video");
      if (video) {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (_) {}
      }
    }
  }

  registerEvents() {
    const opens = this.querySelectorAll(".modal-open");
    const closes = this.querySelectorAll(".modal-close");
    const triggerClass = this.dataset.trigger;

    if (triggerClass) {
      document.addEventListener("click", (e) => {
        const button = e.target.closest("button");
        if (button && button.matches(triggerClass)) {
          this.openModal();
        }
      });
    }

    Array.from(opens).forEach((open) => {
      open.addEventListener("click", (e) => {
        this.openModal();
      });
    });

    Array.from(closes).forEach((close) => {
      close.addEventListener("click", (e) => {
        this.closeModal();
      });
    });
  }
}

customElements.define("site-modal", SiteModal);
